<template>
  <div class="hour">
    <select v-model="hour">
      <option value="00">00</option>
      <option value="01">01</option>
      <option value="02">02</option>
      <option value="03">03</option>
      <option value="04">04</option>
      <option value="05">05</option>
      <option value="06">06</option>
      <option value="07">07</option>
      <option value="08">08</option>
      <option value="09">09</option>
      <option value="10">10</option>
      <option value="11">11</option>
      <option value="12">12</option>
      <option value="13">13</option>
      <option value="14">14</option>
      <option value="15">15</option>
      <option value="16">16</option>
      <option value="17">17</option>
      <option value="18">18</option>
      <option value="19">19</option>
      <option value="20">20</option>
      <option value="21">21</option>
      <option value="22">22</option>
      <option value="23">23</option>
    </select>

    <select v-model="minutes">
      <option value="00">00</option>
      <option value="05">05</option>
      <option value="10">10</option>
      <option value="15">15</option>
      <option value="20">20</option>
      <option value="25">25</option>
      <option value="30">30</option>
      <option value="35">35</option>
      <option value="40">40</option>
      <option value="45">45</option>
      <option value="50">50</option>
      <option value="55">55</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'hour',
  props: [
    'value'
  ],
  watch: {
    hour (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('input', newValue + this.minutes);
      }
    },
    minutes (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('input', this.hour + newValue);
      }
    },
    value (newValue, oldValue) {
      if (newValue !== oldValue) {
        if (!newValue) {
          this.hour = '00';
          this.minutes = '00';
        } else {
          this.hour = newValue.substr(0, 2);
          this.minutes = newValue.substr(2, 2);
        }
      }
    }
  },
  data () {
    return {
      hour: '00',
      minutes: '00'
    }
  },
  mounted () {
    if (!this.value) {
      this.hour = '00';
      this.minutes = '00';
    } else {
      this.hour = this.value.substr(0, 2);
      this.minutes = this.value.substr(2, 2);
    }
  }
}
</script>

<style lang="scss" scoped>
.hour {
  select {
    -webkit-appearance: none;
    background: transparent;
    border: none;
    color: #495057;
    font-size: 0.8125rem;
    line-height: 1.5;
  }
}
</style>
